export abstract class RegistryObject {
    abstract get type(): string;
}
